<template>
  <el-dialog
    title="Kiegyenlítés"
    :visible="true"
    width="300px"
    append-to-body
    :close-on-click-modal="false"
    @close="() => $emit('onClose')"
  >
    <div>
      <el-form
        :model="payee"
        label-position="top"
      >
        <el-form-item
          label="Összeg"
          prop="amount"
        >
          <el-input
            v-model="payee.amount"
            size="small"
          >
            <template slot="append">
              {{ currencyCode }}
            </template>
          </el-input>
        </el-form-item>
        <el-form-item
          label="Dátum"
          prop="date"
        >
          <el-date-picker
            v-model="payee.date"
            type="date"
            size="small"
            style="width: 100%;"
            :clearable="false"
            format="yyyy. MM. dd."
            value-format="yyyy-MM-dd"
            :picker-options="{ firstDayOfWeek: 1 }"
          />
        </el-form-item>
        <el-form-item
          label="Megjegyzés"
          prop="comment"
        >
          <el-input
            v-model="payee.comment"
            size="small"
          />
        </el-form-item>
      </el-form>
      <div style="text-align: right;">
        <el-button size="small"
          type="success"
          :loading="loading"
          @click="save">Mentés
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    props: ['invoiceId', 'defaultAmount', 'currencyCode', 'updateOutstanding', 'onClose'],
    data() {
      return {
        isShown: false,
        loading: false,
        payee: {
          amount: 0,
          comment: '',
          date: new Date()
        }
      };
    },
    watch: {
      defaultAmount(val) {
        this.$set(this.payee, 'amount', this.defaultAmount || 0);
      }
    },
    methods: {
      async save() {
        this.loading = true;
        try {
          await axios.post('api/invoice-payments', {
            invoice_id: this.invoiceId,
            payments: [
              {
                key: Math.random().toString(36).substring(7),
                invoice_id: this.invoiceId,
                payment_date: this.payee.date,
                amount: this.payee.amount,
                comment: this.payee.comment,
              }
            ],
            deleted_payment_ids: []
          });
          this.updateOutstanding(this.invoiceId, this.payee.amount);
          this.$emit('onClose')
        } catch (e) {
          console.log(e)
        }
        this.loading = false;
      }
    },
    mounted() {
      this.$set(this.payee, 'amount', this.defaultAmount || 0);
    }
  };
</script>
